import { TFunction } from 'i18next';
import { TabsType } from '../enums';

export default function getTabs({
  t,
  allCount = 0,
  selectedCount = 0,
}: {
  allCount?: number;
  selectedCount?: number;
  t: TFunction<'translation', undefined>;
}) {
  return [
    {
      label: t('all'),
      value: TabsType.All,
      counter: allCount,
    },
    {
      label: t('selected'),
      value: TabsType.Selected,
      counter: selectedCount,
    },
  ];
}
